<template>
  <section class="exchange-rate">
    <h4 class="exchange-rate__title">
      {{ $t('CP.exchangeRates') }}
    </h4>
    <search-input class="exchange-rate-search" v-model="searchCurrency"
                  @search="(search) => searchCurrency = search"  />
    <ul class="exchange-rate__list">
      <li
        v-for="(currency) of showCurrencies"
        :key="currency.id"
        class="exchange-rate__item"
      >
        {{
          `
          ${currency.exchange_rate[1].toFixed(2)}
          ${currency.cur_description} (${currency.currency}) =
          ${currency.exchange_rate[0].toFixed(2)} ${user.cur_description} (${user.currency})
          `
        }}
      </li>
      <li class="exchange-rate__item exchange-rate__item-empty"
          v-if="searchCurrency && !currencies.length">
        <img src="../../assets/img/sad.svg" alt="sad.svg">
        <p>{{ $t('CP.noCurrencyFound') }}</p>
      </li>
    </ul>
    <div class="exchange-rate_footer">
      <button-app
        class="exchange-rate_close-button"
        @clicked="hideExchangeRateModal"
      >
        {{ $t('CP.close') }}
      </button-app>
      <span class="update-date">
        {{ $t('CP.updated') }}: {{ updateDate }}
      </span>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import SearchInput from '../../components/SearchInput/SearchInput';
import ButtonApp from '../Button/ButtonApp';

export default {
  name: 'ExchangeRateList',
  components: {
    ButtonApp,
    SearchInput,
  },
  data() {
    return {
      updateDate: '',
      searchCurrency: '',
    };
  },
  props: {
    currencyInfo: {
      type: Object,
      default: () => ({
        last_updated: '',
        currencies: [],
        status: '',
      }),
    },
  },
  methods: {
    hideExchangeRateModal() {
      this.$emit('close');
      this.$bvModal.hide('exchange-rate');
    },
    getUpdateDate() {
      try {
        const lastUpdated = `${this.currencyInfo.lastUpdated}Z`;
        this.$moment.locale(localStorage.getItem('locale') || this.$store.state.app.currentLanguage);
        if (this.$moment().diff(this.$moment(lastUpdated), 'days') <= 6) {
          this.updateDate = this.$moment(lastUpdated).calendar();
          return;
        }
        this.updateDate = this.$moment(lastUpdated).format('LLL');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error in dateFormat:');
        // eslint-disable-next-line no-console
        console.error(e);
        this.updateDate = '';
      }
    },
  },
  mounted() {
    this.getUpdateDate();
  },
  watch: {
    locale() {
      this.getUpdateDate();
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.app.currentLanguage,
      user: (state) => state.user.user,
    }),
    currencies() {
      return this.currencyInfo.currencies.filter((currency) => {
        const searchQuery = this.searchCurrency.toLowerCase();
        const currentCurrency = currency.currency.toLowerCase();
        const currentCurrencyLong = currency.cur_description.toLowerCase();
        return currentCurrency.indexOf(searchQuery) !== -1
               || currentCurrencyLong.indexOf(searchQuery) !== -1;
      });
    },
    showCurrencies() {
      return [...this.currencies].filter((cur) => this.user.currency !== cur.currency);
    },
  },
};
</script>

<style lang="scss" scoped>
  .exchange-rate {
    color: var(--text-main-color);
  }
  .exchange-rate__list {
    list-style: none;
    padding: 0 8px 0 0;
    margin: 0;
    min-height: 30vh;
    max-height: 60vh;
    overflow-y: auto;
    /*-ms-overflow-style: none;  !* IE and Edge *!*/
    /*scrollbar-width: none;  !* Firefox *!*/
    /*&::-webkit-scrollbar {*/
    /* display: none; !* Chrome, Safari and Opera *!*/
   /*}*/
  }
  .exchange-rate__item {
    margin: 8px 0;
    padding: 4px;
    border-radius: 8px;
    background: rgba(169, 177, 226, 0.11);
  }
  .exchange-rate_footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .exchange-rate_close-button {
    flex: 0 1 30%;
    margin-right: 20px;
  }
  .update-date {
    flex: 1;
    height: 38px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .exchange-rate-search {
    margin-bottom: 12px;
  }
  .exchange-rate__item-empty {
    align-items: center;
    background: none;
    display: flex;
    flex-direction: column;

    p {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: #303F9F;
      opacity: 0.2;
    }
    img {
      height: 50px;
      width: 70px;
    }
  }
</style>
